import { useEffect, useState } from 'react';
import './NavBar.css';
import { logout } from '../../api/client/client.js';
import useLang, { setLang } from '../../hooks/use-lang/useLang.js';
import logoUrl from '../../assets/logo/fexcloud-header-logo.svg';

const CATEGORIES = [
  { label: 'Metrics', labelKey: 'nav.metrics', icon: 'servers', pages: [
    { label: 'Dashboard', labelKey: 'nav.dashboard', icon: 'dashboard' },
    { label: 'Users', labelKey: 'nav.users', icon: 'users' },
    { label: 'Active Servers', labelKey: 'nav.activeServers', icon: 'servers' },
  ]},
  { label: 'Billing', labelKey: 'nav.billing', icon: 'transactions', pages: [
    { label: 'Transactions', labelKey: 'nav.transactions', icon: 'transactions' },
    { label: 'Plans', labelKey: 'nav.plans', icon: 'plans' },
    // { label: 'Promotions', labelKey: 'nav.promotions', icon: 'promotions' },
  ]},
  { label: 'Security', labelKey: 'nav.security', icon: 'sessions', pages: [
    { label: 'Active Sessions', labelKey: 'nav.activeSessions', icon: 'sessions' },
  ]},
  { label: 'Marketing', labelKey: 'nav.marketing', icon: 'links', pages: [
    { label: 'Ref Links', labelKey: 'nav.refLinks', icon: 'links' },
    { label: 'Affiliate', labelKey: 'nav.affiliate', icon: 'affiliate' },
  ]},
];

function Icon({ icon }) {
  switch (icon) {
    case 'dashboard':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="navbar__icon">
          <path d="M3 12L12 3l9 9v9H3v-9z" />
        </svg>
      );
    case 'users':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="navbar__icon">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <circle cx="17" cy="7" r="4" />
        </svg>
      );
    case 'locations':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="navbar__icon">
          <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0Z" />
          <circle cx="12" cy="10" r="2.5" />
        </svg>
      );
    case 'servers':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="navbar__icon">
          <rect x="2" y="2" width="20" height="8" rx="2" ry="2" />
          <rect x="2" y="14" width="20" height="8" rx="2" ry="2" />
          <line x1="6" y1="6" x2="6.01" y2="6" />
          <line x1="6" y1="18" x2="6.01" y2="18" />
        </svg>
      );
    case 'transactions':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="navbar__icon">
          <rect x="2" y="5" width="20" height="14" rx="2" />
          <line x1="2" y1="10" x2="22" y2="10" />
          <line x1="2" y1="15" x2="22" y2="15" />
        </svg>
      );
    case 'plans':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="navbar__icon">
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
          <rect x="8" y="2" width="8" height="4" rx="1" />
          <line x1="9" y1="10" x2="15" y2="10" />
          <line x1="9" y1="14" x2="15" y2="14" />
        </svg>
      );
    case 'promotions':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="navbar__icon">
          <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
          <line x1="7" y1="7" x2="7.01" y2="7" />
        </svg>
      );
    case 'sessions':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="navbar__icon">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      );
    case 'affiliate':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="navbar__icon">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
      );
    case 'links':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="navbar__icon">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
        </svg>
      );
    default:
      return null;
  }
}

function NavBar({ onNavigate = () => {}, currentPage = '', onLogout = () => {} }) {
  const { lang, t } = useLang();
  const activeCategory = CATEGORIES.find((c) => c.pages.some((p) => p.label === currentPage))?.label ?? null;
  const [openCategory, setOpenCategory] = useState(activeCategory);

  useEffect(() => {
    if (activeCategory) setOpenCategory(activeCategory);
  }, [activeCategory]);

  const toggleLang = () => setLang(lang === 'EN' ? 'UA' : 'EN');

  return (
    <aside className="aside">
      <div className="aside__brand"><img src={logoUrl} alt="FEX Cloud" className="aside__brand-logo" /></div>
      <nav className="aside__nav">
        {CATEGORIES.map((category) => {
          const isOpen = openCategory === category.label;
          return (
          <div key={category.label} className="aside__category">
            <button
              type="button"
              className={`aside__category-header${isOpen ? ' aside__category-header--open' : ''}`}
              onClick={() => setOpenCategory(isOpen ? null : category.label)}
            >
              <Icon icon={category.icon} />
              <span className="aside__category-label">{t(category.labelKey, category.label).toUpperCase()}</span>
              <svg className="aside__category-chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>
            {category.pages && (
              <div className={`aside__pages-wrap${isOpen ? ' aside__pages-wrap--open' : ''}`}>
              <ul className="aside__pages">
                {category.pages.map((page) => (
                  <li key={page.label}>
                    <button
                      className={currentPage === page.label ? 'aside__page-link aside__page-link--active' : 'aside__page-link'}
                      type="button"
                      aria-label={t(page.labelKey, page.label)}
                      onClick={() => onNavigate(page.label)}
                    >
                      <Icon icon={page.icon} />
                      <span className="aside__page-label">{t(page.labelKey, page.label)}</span>
                    </button>
                  </li>
                ))}
              </ul>
              </div>
            )}
          </div>
          );
        })}
      </nav>
      <button className="aside__lang-toggle" onClick={toggleLang} type="button">
        <span className={`aside__lang-pill${lang === 'EN' ? ' aside__lang-pill--left' : ' aside__lang-pill--right'}`} />
        <span className={`aside__lang-label${lang === 'EN' ? '' : ' aside__lang-label--dimmed'}`}>English</span>
        <span className={`aside__lang-label${lang === 'UA' ? '' : ' aside__lang-label--dimmed'}`}>Українська</span>
      </button>
      <div className="aside__user">
        <div className="aside__avatar-container">
          <svg className="aside__user-avatar" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </div>
        <div className="aside__user-info">
          <span className="aside__user-name">{t('nav.adminUser', 'Admin User')}</span>
          <span className="aside__user-role">{t('nav.administrator', 'Administrator')}</span>
        </div>
        <button
          className="aside__logout"
          type="button"
          aria-label={t('nav.logout', 'Logout')}
          onClick={() => { logout(); onLogout(); }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </button>
      </div>
    </aside>
  );
}

export default NavBar;
